import { useCallback, useEffect, useState } from 'react';
import ReactS3Client from 'react-aws-s3-typescript';
import { Modal } from 'react-bootstrap-v5';
import { configBucket } from '../../utils/S3Utils';
import Swal from 'sweetalert2';
import extratoNovaService from '../../services/extratoNovaService';
import { uniqueId } from 'lodash';


const tipos = {
    1: 'Extrato',
    2: 'Carteira de Cobrança',
    3: 'Financeiro - Conta Azul',
    4: 'Financeiro - Omie',
    5: 'Financeiro - Nibo',
    6: 'Financeiro - Asas',
    7: 'Financeiro - Personalizado',
    8: 'Cartão - Visa',
    9: 'Cartão - Mastercard',
    10: 'Cartão - Cielo',
    11: 'Carteira de Pagamento'
} as any

const tiposImportacao = {
    1: 'Excel',
    2: 'Ofx',
    5: 'Pdf',
} as any


const ModalCardImport = ({ esteiraID, show, toggleModal, acc }: { esteiraID: number, show: boolean, toggleModal: Function, acc: string }) => {

    const [listaArquivosImportados, setListaArquivosImportados] = useState<any[]>([]);
    const [tipoSelecionado, setTipoSelecionado] = useState<number>(0);
    const [tipoArquivoSelecionado, setTipoArquivoSelecionado] = useState<number>(0);
    const [tipoBancoSelecionado, setTipoBancoSelecionado] = useState<number>(0);
    const [loadingFile, setLoadingFile] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingRemove, setLoadingRemove] = useState(false);

    const onChangeFile = useCallback(async (e: any) => {
        setLoadingFile(true);
        if (e.target.files !== null && e.target.files.length > 0) {
            const file = e.target.files[0] as File;

            if (tipoSelecionado === 1 && !file.name.includes("xlsx")) {
                Swal.fire({
                    text: 'Para o tipo excel por favor selecione apenas arquivos xlsx.',
                    timer: 5000,
                    icon: 'error',
                    showConfirmButton: false
                });
                setLoadingFile(false);
                return;
            }

            if (tipoSelecionado === 2 && !file.name.includes("pdf")) {
                Swal.fire({
                    text: 'Para o tipo pdf por favor selecione apenas arquivos pdf.',
                    timer: 5000,
                    icon: 'error',
                    showConfirmButton: false
                });
                setLoadingFile(false);
                return;
            }

            const s3 = new ReactS3Client(configBucket);
            const res = await s3.uploadFile(file);

            const result = await extratoNovaService.cadastrarAnexo(esteiraID, tipoSelecionado, tipoBancoSelecionado, tipoArquivoSelecionado, acc, file.name, res.key);
            console.log(result);
            setListaArquivosImportados((old) => {
                const cp = [...old];
                cp.push(result);
                return cp;
            })
        }
        setLoadingFile(false);
    }, [acc, tipoSelecionado, tipoBancoSelecionado, esteiraID, tipoArquivoSelecionado]);

    const onProccess = useCallback(async () => {
        setLoading(true);
        await extratoNovaService.processar(esteiraID, acc).then(() => {
            Swal.fire({
                text: 'Extrato inserido para processamento.',
                timer: 5000,
                icon: 'success',
                showConfirmButton: false
            });
        }).catch(() => {
            Swal.fire({
                text: 'Ocorreu um erro ao inserir o extrato para processamento.',
                timer: 5000,
                icon: 'error',
                showConfirmButton: false
            });
        });

        toggleModal(false);
        setLoading(false);
        setListaArquivosImportados([]);
    }, [acc, esteiraID]);

    const onRemove = useCallback(async (id: number) => {
        if (!loadingRemove) {
            setLoadingRemove(true)
            await extratoNovaService.removerAnexo(id)
            setListaArquivosImportados((old) => {
                const cp = [...old]
                const result = cp.filter(f => f.id !== id)
                return result
            })
            setLoadingRemove(false)
        }
    }, [loadingRemove])


    return (
        <Modal size='xl' centered={true} show={show} scrollable onHide={() => onProccess()}>
            <div className="modal-content" style={{ backgroundColor: '#F4F5F7' }}>
                <div className="modal-header">
                    <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                        <i onClick={() => toggleModal(true)} className="fas fa-arrow-left" style={{ color: '#5E6397' }}></i>
                    </div>
                    <h5 className="modal-title titulo-modal" style={{ textTransform: 'uppercase' }}>Importação de Extratos</h5>
                </div>
                <div className="modal-body" id="scrollableDiv">
                    <div className='row'>
                        {listaArquivosImportados.length > 0 ? (
                            <div>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">Nome</th>
                                            <th scope="col">Tipo Arquivo</th>
                                            <th scope="col">Tipo</th>
                                            <th scope="col"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {listaArquivosImportados.map((item) => (
                                            <tr key={uniqueId()}>
                                                <th scope="row">{item.path}</th>
                                                <th scope="row">{tipos[item.tipoArquivo]}</th>
                                                <th scope="row">{tiposImportacao[item.tipo]}</th>
                                                <th>
                                                    {!loadingRemove ? <i onClick={() => onRemove(item.id)} className="fas fa-trash" style={{ color: 'red' }}></i> : <div className="spinner-border text-success" role="status">
                                                        <span className="sr-only">Loading...</span>
                                                    </div>}</th>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div className='col-md-12'>
                                <h5>Não foi encontrado nenhum arquivo importado na conta</h5>
                            </div>
                        )}

                        <div className='col-md-12 mt-4'>
                            <div className='row'>
                                <div className='col-md-4 mt-2'>
                                    <div className='form-group'>
                                        <label htmlFor="">Tipo</label>
                                        <select disabled={loadingFile} className='form-control' value={tipoArquivoSelecionado} onChange={(e) => setTipoArquivoSelecionado(parseInt(e.target.value))}>
                                            <option value={0}>Selecione um tipo</option>
                                            <option value={1}>Extrato</option>
                                            <option value={2}>Carteira de Cobrança</option>
                                            <option value={3}>Financeiro - Conta Azul</option>
                                            <option value={4}>Financeiro - Omie</option>
                                            <option value={5}>Financeiro - Nibo</option>
                                            <option value={6}>Financeiro - Asas</option>
                                            <option value={7}>Financeiro - Personalizado</option>
                                            <option value={8}>Cartão - Visa</option>
                                            <option value={9}>Cartão - Mastercard</option>
                                            <option value={10}>Cartão - Cielo</option>
                                            <option value={11}>Carteira de Pagamento</option>
                                        </select>
                                    </div>
                                </div>
                                <div className='col-md-4 mt-2'>
                                    <div className='form-group'>
                                        <label htmlFor="">Formato</label>
                                        <select disabled={loadingFile} className='form-control' value={tipoSelecionado} onChange={(e) => setTipoSelecionado(parseInt(e.target.value))}>
                                            <option value={0}>Selecione um tipo</option>
                                            <option value={1}>Excel</option>
                                            <option value={3}>Ofx</option>
                                            <option value={5}>Pdf</option>
                                        </select>
                                    </div>
                                </div>
                                <div className='col-md-4 mt-2'>
                                    <label htmlFor="">Banco</label>
                                    <div className='form-group'>
                                        <select disabled={loadingFile} className='form-control' value={tipoBancoSelecionado} onChange={(e) => setTipoBancoSelecionado(parseInt(e.target.value))}>
                                            <option value={0}>Selecione um tipo</option>
                                            <option value={2}>Itaú</option>
                                            <option value={1}>Santander</option>
                                            <option value={4}>Caixa</option>
                                            <option value={5}>PagBank</option>
                                            <option value={6}>Bradesco</option>
                                            <option value={3}>Banco do Brasil</option>
                                            <option value={7}>Inter</option>
                                            <option value={8}>Safra</option>
                                            <option value={10}>Santander American</option>
                                            <option value={11}>Sicred</option>
                                            <option value={12}>Sicoob</option>
                                            <option value={13}>C6</option>
                                            <option value={14}>Nubank</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-12 mt-2">
                                    <label>Selecione um arquivo para importar</label>
                                    {loadingFile ? <p>Carregando...</p> : (
                                        <div className="form-group mt-2">
                                            <input type='file' placeholder='Anexar...' accept='*' onChange={(e) => onChangeFile(e)} className="form-control" disabled={loading} />
                                        </div>)
                                    }
                                </div>
                                <div className='col-md-3 mt-2'>
                                    <button onClick={onProccess} disabled={(listaArquivosImportados.length == 0 || loading || loadingFile)} className='btn btn-success'>Processar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal >
    )
}

export default ModalCardImport;